import React, { PureComponent, Fragment } from 'react'
import styles from './CirBtn.scss'
import $ from 'jquery'

export default class CirBtn extends PureComponent {
  componentDidMount() {
    const scrollFuc = (scrto) => {
      $('html, body').animate(
        { scrollTop: $('.' + scrto).offset().top - $('.header').height() },
        { duration: 600, easing: 'swing' },
      )
    }
    $('.Btn').on('click', () => {
      scrollFuc('form')
    })
  }
  render() {
    return (
      <Fragment>
        <style jsx>{styles}</style>
        <div className="cirbtn Btn">
          <img src="/statics/images/creator/landingPage/cirbtn.png" />
        </div>
      </Fragment>
    )
  }
}
